import React, { useState } from 'react';
import { BringzzPageContainer, BringzzInput, BringzzText } from "@bringzz/components";
import HeaderCategory from './HeaderCategory';
import SearchFooter from './SearchFooter';
import Companies from './Companies';
import SearchModal from './SearchModal';
import { getCategories, alphabets } from './constants';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

const INITIAL_HEADER_HEIGHT = 214;

const CompaniesPage = () => {
    const { t } = useTranslation();
    const [headerHeight, setHeaderHeight] = useState(INITIAL_HEADER_HEIGHT);
    const [MIN_HEADER_HEIGHT, SET_MIN_HEADER_HEIGHT] = useState(100);
    const [alphabetFilter, setAlphabetFilter] = useState('All');
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const [companyFilter, setCompanyFilter] = useState(null);
    const [searchData, setSearchData] = useState({
        method: "category",
        value: t('component.search.categories.companies.short') || 'Companies',
        results: []
    });

    const allCategories = getCategories(t);

    return (
        <BringzzPageContainer
            className="bg-sand"
            footerHover={true}
            footer={
                <div className='p-4'>
                    <BringzzInput
                        className='shadow-xl border-slate-400 bg-gray-100 cursor-pointer'
                        placeholder={t('component.search.general.find_items')}
                        readOnly
                        onClick={() => setIsSearchModalOpen(true)}
                    />
                </div>
            }
        >
            <div className='relative'>
                <HeaderCategory
                    SET_MIN_HEADER_HEIGHT={SET_MIN_HEADER_HEIGHT}
                    searchData={searchData}
                    setSearchData={setSearchData}
                    headerHeight={headerHeight}
                    categories={allCategories}
                />
                <div style={{ paddingTop: `${INITIAL_HEADER_HEIGHT}px` }}>
                    <div className='rounded-xl bg-white mx-2 py-2'>
                        <div className='flex items-center px-4 space-x-3 sm:space-x-2 overflow-x-auto'>
                            <BringzzText tag='h3' className='whitespace-nowrap mr-1'>{t('component.search.general.alphabet_filter')}</BringzzText>
                            {alphabets.map((char, index) => (
                                <div
                                    key={index}
                                    className={classNames('bg-sand p-2 rounded-full cursor-pointer flex-shrink-0',
                                        char === alphabetFilter && "!bg-magic-lilac"
                                    )}
                                    onClick={() => setAlphabetFilter(char)}
                                >
                                    <BringzzText tag='h5'>{char}</BringzzText>
                                </div>
                            ))}
                        </div>
                        <Companies 
                            selectedLetter={alphabetFilter}
                            setSearchData={setSearchData} 
                            callBack={() => {
                                SET_MIN_HEADER_HEIGHT(100);
                                setHeaderHeight(190);
                            }}
                            onCompanyProductsClick={(companyId, companyName) => {
                                setCompanyFilter({ id: companyId, name: companyName });
                                setIsSearchModalOpen(true);
                            }}
                        />
                    </div>
                    <SearchFooter />
                </div>
            </div>
            <SearchModal 
                isOpen={isSearchModalOpen} 
                onClose={() => {
                    setIsSearchModalOpen(false);
                    setCompanyFilter(null);
                }}
                companyId={companyFilter?.id}
                companyName={companyFilter?.name}
            />
        </BringzzPageContainer>
    );
};

export default CompaniesPage;